module.exports = __webpack_public_path__ + "static/media/expend1.db5ef66.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/expend1.mp4
// module id = edKn
// module chunks = 0